module.exports = __webpack_public_path__ + "img/ZKFair.beeed965.png";